import { useCallback } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { CircleFilledIcon } from 'foundations-assets';
// @ts-expect-error Untyped import
import { useShowDialog } from '../../../dialog/ducks';
// @ts-expect-error Untyped import
import { useUserRoleFromScopes } from '../../../utils/trackingUtils';
import { EVENTS } from '../../../utils/usageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulkSetBusinessUnitAction = ({
  assets,
  assetType,
  dialogType,
  filters,
  filteredAssetCount,
  problemAndMessage,
  onSetBusinessUnitSuccess = () => {},
  usageTracker
}) => {
  const userRole = useUserRoleFromScopes();
  const showDialog = useShowDialog();
  const assetCount = !assets.length && filteredAssetCount ? filteredAssetCount : assets.length;
  const {
    problem,
    disabledMessage
  } = problemAndMessage;
  const handleClick = useCallback(() => {
    if (usageTracker) {
      usageTracker.track(EVENTS.clickUpdateAsset, {
        action: 'set-business-unit',
        actionType: 'edit',
        assetType,
        count: assetCount,
        object: 'business unit',
        role: userRole
      });
    }
    showDialog({
      dialogType,
      dialogProps: {
        assets,
        assetCount,
        filters,
        onSetBusinessUnitSuccess,
        usageTracker
      }
    });
  }, [assetCount, assetType, assets, dialogType, filters, onSetBusinessUnitSuccess, showDialog, usageTracker, userRole]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabledMessage,
    disabled: !problem,
    children: /*#__PURE__*/_jsxs(Button, {
      onClick: handleClick,
      disabled: !!problem,
      use: "link",
      children: [/*#__PURE__*/_jsx(CircleFilledIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.setBusinessUnit.button.text_buv2"
      })]
    })
  });
};